import { jsxs as r, jsx as l } from "react/jsx-runtime";
const h = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m33.617 46.085-4.424 1.185 1.185 4.424 4.424-1.185-1.185-4.424Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M49.5 52.93V6H18.48c-2.2 0-3.98 1.78-3.98 3.98V54.1c0 2.15 1.74 3.9 3.9 3.9h28.17l-1.07-4h-27V43.99h27V54l4-1.07Zm-31-10.94V10h27v31.98l-27 .01Z"
        }
      )
    ]
  }
);
export {
  h as Mobile
};
